export const MENU_LABELS = {
  copy: 'Make a copy',
  copyAsTemplate: 'Copy as template',
  unlink: 'Unlink project',
} as const
